import { ClientError } from "graphql-request";
export class GraphQLError extends Error {
    constructor(error, document, variables) {
        var _a, _b;
        const message = error instanceof ClientError ? error.message : "Unknown GraphQL error";
        super(message);
        this.document = document;
        if (error instanceof ClientError) {
            this.response = error.response;
            this.request = error.request;
        }
        this.name = "GraphQLError";
        this.variables = JSON.stringify(variables);
        this.errorCodes = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.map((e) => String(e.code));
    }
}
//# sourceMappingURL=GraphQLError.js.map